import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto9() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.24 46.24" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path
						class="cls-1"
						d="M37.28,31.56l7.78,7.79a4,4,0,0,1-5.71,5.71l-7.79-7.78-4.47,5.93a1.59,1.59,0,0,1-2.74-.36l-11-27.41a1.59,1.59,0,0,1,2.06-2.06l27.4,11a1.58,1.58,0,0,1,.37,2.74l-5.93,4.47Zm4.5-5.68L15.28,15.27,25.89,41.78l4.6-6.1a1.27,1.27,0,0,1,1.92-.13l8.23,8.22a2.22,2.22,0,0,0,3.13-3.14l-8.22-8.22a1.28,1.28,0,0,1,.14-1.93l6.09-4.6Z"
					/>
					<path d="M4.62,5.91A.91.91,0,0,1,5.91,4.62L10.25,9A.91.91,0,0,1,9,10.25Z" />
					<path d="M14.86.91a.92.92,0,0,1,1.83,0V7.05a.92.92,0,0,1-1.83,0Z" />
					<path d="M25.64,4.62a.91.91,0,0,1,1.29,1.29l-4.34,4.34A.91.91,0,0,1,21.3,9Z" />
					<path d="M5.91,26.93a.91.91,0,0,1-1.29-1.29L9,21.3a.91.91,0,0,1,1.29,1.29L5.91,26.93Z" />
					<path d="M.91,16.69a.92.92,0,0,1,0-1.83H7.05a.92.92,0,0,1,0,1.83Z" />
				</g>
			</g>
		</svg>
	);
}
